export enum AuthStatus {
  Unauthenticated = 0,
  Authenticated = 1
}
